"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActiveOrganizationId = getActiveOrganizationId;
exports.getPathAfterOrganizationChange = getPathAfterOrganizationChange;
function getActiveOrganizationId(profile) {
  if (profile) {
    return profile.properties && profile.properties.cs_auth ? profile.properties.cs_auth.activeOrganizationId : profile.organization.id;
  }
  return null;
}
function getPathAfterOrganizationChange(homeQuery, activeOrganizationId, newOrganizationId, config, getPath) {
  var homePathName = getPath('home');
  if (!homeQuery) {
    return homePathName;
  }
  if (homeQuery.organizationId === activeOrganizationId) {
    return {
      pathname: homePathName,
      query: {
        organizationId: newOrganizationId
      }
    };
  }
  if (homeQuery.organizationId === config.mulesoft.id) {
    return {
      pathname: homePathName,
      query: {
        organizationId: config.mulesoft.id
      }
    };
  }
  return homePathName;
}
//# sourceMappingURL=utils.js.map